<style src="./CmedMap.scss" lang="scss" scoped></style>
<template>
  <section class="cmed-map">
    <ul class="grid-list-container">
      <li
        class="cmed-grid-row"
        v-for="(item, itemIdx) in listData"
        :key="itemIdx">
        <div class="info-1">
          <span class="ncomercial">{{ item.comercialName }}</span>
          <span class="lab">{{ item.lab }}</span>
        </div>

        <div class="info-2">
          <span class="pativo">{{ item.pativo }}</span>
        </div>

        <div class="info-3">
          <span class="presentation">{{ item.presentation }}</span>
        </div>

        <div class="info-4">
          <span class="factor">{{ item.factor | DecimalNumber }}</span>
        </div>

        <div class="info-5">
          <span class="values">{{ item.pfLocal | CurrencyBR }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'

export default {
  name: 'CmedMap',
  props: {
    listData: {
      default: null
    }
  },
  filters: {CurrencyBR, DecimalNumber}
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/components/cmed-map/CmedMap.vue